import { render, staticRenderFns } from "./pe_list_meal.vue?vue&type=template&id=9bdf5f70&scoped=true"
import script from "./pe_list_meal.vue?vue&type=script&lang=js"
export * from "./pe_list_meal.vue?vue&type=script&lang=js"
import style0 from "./pe_list_meal.vue?vue&type=style&index=0&id=9bdf5f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdf5f70",
  null
  
)

export default component.exports